<template>
  <page-outline :title="$t('mandate.create_payment_schedule')">
    <template slot="pageContent">
      <b-row class="min-w-100 justify-content-start align-items-center">
        <b-col cols="12" class="d-flex justify-content-start mt-3 mb-5">
          <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl" :menuLink="'/mandatpage/unit'"></back-button>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12" class="mt-3">
          <div>
            <form-accordion :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <form-read-group-label-input
                    :inputLabel="$t('mandate.unique_mandate_rf')" :inputValue="UMR">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="5">
                  <form-read-group-label-input
                    :inputLabel="$t('mandate.dbtr')" :inputValue="debtor">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('mandate.cdtr_info')" :isTitleUpperCase="false">
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <iban-input
                    v-model="IbanSelected"
                    :label="$t('mandate.cdtr_iban')"
                    :required="true"
                    :hint="$t('mandate.iban_hint') || ''"
                  />
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('mandate.payment_schedule_details')" :isTitleUpperCase="false">
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="debitReason"
                    :inputLabel="$t('mandate.rsn_debit')"
                    :placeholderValue="$t('mandate.rsn_debit')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="5">
                  <label>
                    {{ $t('mandate.frequency_type') }} <span style="color: red">*</span>
                  </label>
                  <select class="form-control" v-model="frequencyType">
                    <option value="" disabled selected>{{ $t('mandate.frequency_type_select') }}</option>
                    <option v-for="type in FrequencyTypeList" :key="type.value" :value="type.value">
                      {{ $t(type.label) }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row v-if="frequencyType == 1" class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="Amount"
                    :inputLabel="$t('mandate.amt') + ' (€)'"
                    :placeholderValue="$t('mandate.amt') + ' (€)'"
                    isMandatory
                    inputType="number">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="5">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_first_debit') }} <span style="color: red">*</span></span>
                    <datetime-picker-custom
                      format="YYYY-MM-DD"
                      periodFull
                      id="filter-datebegin"
                      class="mr-3"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': firstDebitateDate}"
                      customInputParentClass="filter-item-content"
                      customInputClass="w-100"
                      style="padding:0.35rem"
                      :maxLength="19"
                      :placeholderValue="$t('common.datepicker_format_date3')"
                      inputIcon="fa-solid fa-calendar"
                      disablePastDates
                      :showTime="false"
                      v-model="firstDebitateDate"/>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="frequencyType == 1" class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <label>
                    {{ $t('mandate.periodicity') }} <span style="color: red">*</span>
                  </label>
                  <select class="form-control" v-model="periodicity">
                    <option value="" disabled selected>{{ $t('mandate.periodicity_select') }}</option>
                    <option v-for="p in periodicityList" :key="p.value" :value="p.value">
                      {{ $t(p.label) }}
                    </option>
                  </select>
                </b-col>
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="numberOfOccurences"
                    :inputLabel="$t('mandate.nb_occurences')"
                    :placeholderValue="$t('mandate.nb_occurences')"
                    inputType="number">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row v-if="frequencyType == 1" class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_end') }}
                      <!-- <span style="color: red">*</span> -->
                    </span>
                    <datetime-picker-custom
                      format="YYYY-MM-DD"
                      periodFull
                      id="filter-datebegin"
                      class="mr-3"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': endDate}"
                      customInputParentClass="filter-item-content"
                      customInputClass="w-100"
                      style="padding:0.35rem"
                      :maxLength="19"
                      :placeholderValue="$t('common.datepicker_format_date3')"
                      inputIcon="fa-solid fa-calendar"
                      disablePastDates
                      :showTime="false"
                      v-model="endDate"/>
                  </div>
                </b-col>
              </b-row>
              <div v-if="frequencyType == 0 && frequencyType !== ''" class="ml-0 mr-5">
                <b-button class="btn btn-tertiary mb-4" @click.prevent="addPaymentSchedule">
                  <i class="fa-solid fa-plus"></i> {{ $t('mandate.add_payment_date') }}
                </b-button>

                <div class="rounded p-4 trackingAccordion mb-4" v-for="(ps, index) in list" :key="index">
                  <b-row>
                    <b-col sm="5">
                      <form-write-group-label-input
                        v-model="ps.amount"
                        :inputLabel="$t('mandate.amt') + ' (€)'"
                        inputType="number"
                        isMandatory>
                      </form-write-group-label-input>
                    </b-col>

                    <b-col sm="5">
                      <div>
                        <span class="filter-item-title d-block mb-1">
                          {{ $t('mandate.payment_schedule_date') }} <span style="color:red">*</span>
                        </span>
                        <datetime-picker-custom
                        format="YYYY-MM-DD"
                        periodFull
                        id="filter-datebegin"
                        class="mr-3"
                        :class="{'filter-item-input': true, 'filter-item-input-complete': paymentScheduleDate}"
                        customInputParentClass="filter-item-content"
                        customInputClass="w-100"
                        style="padding:0.35rem"
                        :maxLength="19"
                        :placeholderValue="$t('common.datepicker_format_date3')"
                        inputIcon="fa-solid fa-calendar"
                        disablePastDates
                        :showTime="false"
                        v-model="ps.paymentScheduleDate"/>
                      </div>
                    </b-col>
                  </b-row>

                  <b-button class="btn btn-tertiary mt-3" @click.prevent="removePaymentSchedule(index)">
                    <i class="fa-solid fa-trash"></i> {{ $t('mandate.delete_payment_date') }}
                  </b-button>
                </div>
              </div>
            </form-accordion>
            <b-row class="form-group justify-content-end">
              <b-col sm="2">
                <b-button
                  class="btnFilter_2"
                  variant="primary"
                  @click="sendPaymentSchedule"
                  :disabled="!isFormValid">
                  <i class="fa-light fa-paper-plane" size="17px"></i>
                  <span>{{ $t('mandate.send') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import { errorMessageAlert } from "@/helpers/alert"
import moment from 'moment-timezone'
import BackButton from '@/components/common/backButton.vue'
import IbanInput from '@/components/common/IbanInput.vue'
import { normalizeIban, validateIban } from '@/helpers/iban'

export default {
  components: {
    BackButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    'iban-input': IbanInput
  },
  data () {
    return {
      Amount: '',
      debitReason: '',
      endDate: '',
      firstDebitateDate: '',
      FrequencyTypeList: [
        { value: 0, label: 'mandate.frequency_type_0' },
        { value: 1, label: 'mandate.frequency_type_1' }
      ],
      frequencyType: '',
      IbanSelected: '',
      numberOfOccurences: '',
      list: [],
      periodicity: '',
      periodicityList: [
        { value: 'Daily', label: 'mandate.periodicity_daily' },
        { value: 'Monthly', label: 'mandate.periodicity_monthly' },
        { value: 'Yearly', label: 'mandate.periodicity_yearly' }
      ],
      status: 1,
      timezone: '+00:00'
    }
  },
  created() {
    this.idMandate = this.$route.query.idMandate
    this.UMR = this.$route.query.UMR
    this.debtor = this.$route.query.debtor
    this.returnUrl = '/mandatedetail/' + this.idMandate
  },
  computed: {
    isFormValid() {
      const hasIBAN = (this.IbanSelected || '').trim().length > 0
      const hasFrequencyType = this.frequencyType !== ''

      if (this.frequencyType == 1) {
        const hasAmount = (this.Amount || '').trim().length > 0
        const hasFirstDebitateDate = (this.firstDebitateDate || '').trim().length > 0
        const hasFirstDebitateDateValid = this.isValidDate(this.firstDebitateDate)
        const hasPeriodicity = (this.periodicity || '').trim().length > 0
        const hasEndDateValid = !this.endDate || this.isValidDate(this.endDate)
        return (
          hasIBAN &&
          hasFrequencyType &&
          hasAmount &&
          hasFirstDebitateDate &&
          hasFirstDebitateDateValid &&
          hasPeriodicity &&
          hasEndDateValid
        )
      }
      if (this.frequencyType == 0) {
        if (!this.list.length) return false
        for (const item of this.list) {
          if (!item.amount) return false
          if (!item.paymentScheduleDate) return false
          if (!this.isValidDate(item.paymentScheduleDate)) return false
        }
        return hasIBAN && hasFrequencyType
      }
      return false
    }
  },
  // watch: {
  //   IbanSelected(value) {
  //     if (value) {
  //       this.IbanSelected = value.replace(/\s+/g, '')
  //     }
  //   }
  // },
  methods: {
    addPaymentSchedule () {
      const newLine = { amount: '', paymentScheduleDate: '' }
      this.list = [...this.list, newLine]

      this.amount = ''
      this.paymentScheduleDate = ''
    },
    removePaymentSchedule (index) {
      this.list.splice(index, 1)
    },
    formHasError () {
      // if (this.IbanSelected === undefined || this.IbanSelected === '') {
      //   this.okMessageBox(this.$t('mandate.missing_iban'))
      //   return true
      // }
      // if (!this.isValidIban(this.IbanSelected)) {
      //   this.okMessageBox(this.$t('mandate.invalid_iban'))
      //   return true
      // }
      const res = validateIban(this.IbanSelected)

      if (!res.valid) {
        let msg = ''

        if (this.$t) {
          switch (res.code) {
            case 'empty':
              msg = this.$t('mandate.iban_required')
              break
            case 'invalid_chars':
              msg = this.$t('mandate.iban_invalid_chars')
              break
            case 'too_short':
              msg = this.$t('mandate.iban_too_short')
              break
            case 'country_not_supported':
              msg = this.$t('mandate.iban_country_not_supported', {
                country: res.country || ''
              })
              break
            case 'wrong_length':
              msg = this.$t('mandate.iban_wrong_length', {
                country: res.country || ''
              })
              break
            case 'checksum':
              msg = this.$t('mandate.iban_invalid_checksum')
              break
            default:
              msg = this.$t('mandate.iban_invalid_generic') || 'IBAN invalide'
          }
        } else {
          msg = 'IBAN invalide'
        }

        this.okMessageBox(msg)
        return true
      }
      // if (this.frequencyType === undefined || this.frequencyType === '') {
      //   this.okMessageBox(this.$t('mandate.missing_frequency_type'))
      //   return true
      // }
      // if ((this.Amount === undefined || this.Amount === '') && this.frequencyType === 1 ) {
      //   this.okMessageBox(this.$t('mandate.missing_amt'))
      //   return true
      // }
      // if ((this.firstDebitateDate === undefined || this.firstDebitateDate === '') && this.frequencyType === 1) {
      //   this.okMessageBox(this.$t('mandate.missing_date_first_debit'))
      //   return true
      // }
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const minFirstDebitateDate = new Date(today)
      minFirstDebitateDate.setDate(today.getDate() + 14)

      const firstDebitDate = new Date(this.firstDebitateDate)
      firstDebitDate.setHours(0, 0, 0, 0)

      if (firstDebitDate < minFirstDebitateDate && this.frequencyType === 1) {
        this.okMessageBox(this.$t('mandate.first_debit_min_14_days'))
        return true
      }

      if (this.frequencyType === 0) {
        if (!this.list || this.list.length === 0) {
          this.okMessageBox(this.$t('mandate.add_payment_date'))
          return true
        }

        for (const [index, item] of this.list.entries()) {
          // if (!item.amount || item.amount === '') {
          //   this.okMessageBox(this.$t('mandate.missing_amt', { line: index + 1 }))
          //   return true
          // }
          // if (!item.paymentScheduleDate || item.paymentScheduleDate === '') {
          //   this.okMessageBox(this.$t('mandate.missing_payment_schedule_date', { line: index + 1 }))
          //   return true
          // }
          const paymentScheduleDate = new Date(item.paymentScheduleDate)
          paymentScheduleDate.setHours(0, 0, 0, 0)
          if (paymentScheduleDate < minFirstDebitateDate) {
            this.okMessageBox(this.$t('mandate.payment_schedule_date_min_14_days'))
            return true
          }

        }
      }
      // if ((this.periodicity === undefined || this.periodicity === '') && this.frequencyType === 1) {
      //   this.okMessageBox(this.$t('mandate.missing_periodicity'))
      //   return true
      // }
      // if (
      //   this.frequencyType === 1 &&
      //   (
      //     (this.endDate === undefined || this.endDate === '') &&
      //     (this.numberOfOccurences === undefined || this.numberOfOccurences === '')
      //   )
      // ) {
      //   this.okMessageBox(this.$t('mandate.enddate_or_nbocc_required'))
      //   return true
      // }
      // if ((this.endDate === undefined || this.endDate === '') && this.frequencyType === 1) {
      //   this.okMessageBox(this.$t('mandate.missing_end_date'))
      //   return true
      // }
      // if ((this.numberOfOccurences === undefined || this.numberOfOccurences === '') && this.frequencyType === 1) {
      //   this.okMessageBox(this.$t('mandate.missing_nb_occurences'))
      //   return true
      // }
      if (
        this.frequencyType === 1 &&
        this.endDate &&
        this.firstDebitateDate &&
        this.periodicity
      ) {
        const end = new Date(this.endDate)
        const first = new Date(this.firstDebitateDate)
        let minEndDate = new Date(first)

        if (this.periodicity === 'Daily') {
          minEndDate.setDate(first.getDate() + 1)
        } else if (this.periodicity === 'Monthly') {
          minEndDate.setMonth(first.getMonth() + 1)
        } else if (this.periodicity === 'Yearly') {
          minEndDate.setFullYear(first.getFullYear() + 1)
        }

        const endDateOnly = end.toISOString().split('T')[0]
        const minEndDateOnly = minEndDate.toISOString().split('T')[0]

        if (endDateOnly < minEndDateOnly) {
          this.okMessageBox(this.$t('mandate.end_date_after_first_debit'))
          return true
        }
      }

      return false
    },
    isValidDate(date) {
      return /^\d{4}-\d{2}-\d{2}$/.test(date)
    },
    // isValidIban (iban) {
    //   if (!iban) return false
    //
    //   const clean = iban.replace(/\s+/g, '')
    //   return clean.length === 27
    // },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    sendPaymentSchedule () {
      let that = this

      if (!this.isFormValid) return

      if (this.formHasError()) {
        return
      }

      const cleanIban = normalizeIban(this.IbanSelected)

      let params = {
        idMandate: this.idMandate,
        UMR: this.UMR,
        debitReason: this.debitReason,
        frequencyType: this.frequencyType,
        status: this.status,
        CdtrIBAN: cleanIban
      }
      if (this.frequencyType === 1) {
        params.Amount = this.Amount
        params.firstDebitateDate = this.firstDebitateDate,
        params.periodicity = this.periodicity
        params.endDate = this.endDate
        params.numberOfOccurences = this.numberOfOccurences

      } else if (this.frequencyType === 0) {
        params.list = this.list.map(item => ({
          amount: item.amount,
          paymentScheduleDate: item.paymentScheduleDate
        }))
      }
      this.$engine.paymentSchedule.addPaymentSchedule(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('mandate.added_payment_schedule'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/payment-schedules/unit'})
      })
      .catch(e => {
        errorMessageAlert(e, that, that.$i18n)
      })
    }
  }
}
</script>
